import { GameObject } from "../core/GameObject";
import { Vec2 } from "planck-js";
import PlayerData from "../PlayerData";
import { GameScene } from "../scenes/GameScene";
import { DestroyOffscreen } from "./DestroyOffscreen";
import { PlanckBodyComponent, PlanckBodyType } from "./PlanckBodyComponent";
import { Player } from "./Player";
import { DestroyInWall } from "./DestroyInWall";

export class NPCRunner extends GameObject {
	gameScene: GameScene;
    spineName: string;
	spine: SpineGameObject;
	spineContainer: SpineContainer;
	planckBody: PlanckBodyComponent;

    // characterAnims: {[key: string]: string} = {
    //     "bugs": "run",
	// 	"lola": "run",
	// 	"daffy": "run",
	// 	"tweety": "animation",
	// 	"porky": "run",
	// 	"roadrunner": "animation",
	// 	"sylvester": "run",
	// 	"taz": "animation",
	// 	"wile": "animation",
    // }	

	constructor(scene: GameScene, x: number, y: number, speed: number, name: string) {
		super(scene);
		this.gameScene = scene;
		const hitboxWidth = 150;
		const hitboxHeight = 130;

		this.x = x;
		this.y = y - hitboxHeight * 0.6;
        
        this.spineName = name;
		this.spine = this.scene.add.spine(0, 0, "npc-" + name, "run", true);
		this.spine.y += hitboxHeight * 0.4;
        this.spine.scale = 0.4;
		this.spineContainer = this.scene.add.spineContainer(0, 50, this.spine);
		this.add(this.spineContainer);

		// const img = this.addImage("whiteSquare");
		// img.alpha = 0.5;
		// img.setDisplaySize(hitboxWidth, hitboxHeight);
		// this.setSize(hitboxWidth, hitboxHeight);
		// img.tint = 0xAAAAAA;

		this.planckBody = this.addComponent(new PlanckBodyComponent(this, PlanckBodyType.BOX, {
			x: this.x, y: this.y,
			width: hitboxWidth, height: hitboxHeight,
			worldScale: GameScene.worldScale,
			isKinematic: true,
			isSensor: false,
		}));
		this.planckBody.velocity.x = speed;

		this.addComponent(new DestroyOffscreen(this, true, true, 1000));
		this.addComponent(new DestroyInWall(this));
	}

	playImpact(coinCount: number, target: Player): void {
		this.gameScene.missionTracker.updateMissionProgress("stunCharacters", 1);

		for (let i = 0; i < coinCount; i++) {
			const sprite = this.scene.add.sprite(0, 0, "coin-sheet");
			sprite.play("coinIdle");

			const worldView = this.gameScene.cameraController.getRealWorldView();
			const xFrac = (this.x - worldView.left) / worldView.width;
			const yFrac = (this.y - worldView.top) / worldView.height;

			const screenPos = new Vec2(xFrac * this.scene.viewport.width, yFrac * this.scene.viewport.height);
			sprite.setPosition(screenPos.x, screenPos.y);
			this.gameScene.uiContainer.add(sprite);
			
			const xFrac2 = (target.x - worldView.left) / worldView.width;
			const yFrac2 = (target.y - worldView.top) / worldView.height;
			let playerPos = new Vec2(xFrac2 * this.scene.viewport.width, yFrac2 * this.scene.viewport.height);
	
			const gameScene = this.gameScene;
			const timeline = gameScene.tweens.createTimeline();
			let tween: Phaser.Tweens.Tween | undefined = undefined;
			timeline.add({
				targets: sprite,
				x: sprite.x + Phaser.Math.RND.between(-200, 200),
				y: sprite.y + Phaser.Math.RND.between(-200, 0),
				duration: 100,
				ease: Phaser.Math.Easing.Quadratic.In,
				onComplete: () => {
					
					gameScene.ltGame.player.collectCoin();
					tween = gameScene.tweens.add({
						targets: sprite,
						alpha: 0,
						duration: 99999,
						onUpdate: () => {
							const xFrac2 = (target.x - worldView.left) / worldView.width;
							const yFrac2 = (target.y - worldView.top) / worldView.height;
							playerPos = new Vec2(xFrac2 * gameScene.viewport.width, yFrac2 * gameScene.viewport.height);
							sprite.y += (playerPos.y - sprite.y) / 10;
						}
					})
				},
			});
			timeline.add({
				targets: sprite,
				x: playerPos.x,
				duration: 100,
				ease: Phaser.Math.Easing.Quadratic.Out,
				onComplete: () => {
					if (i == 0) {
						sprite.play("coinBurst");
						sprite.once("animationcomplete", () =>{
							tween.stop();
							sprite.destroy();
						});
					} else {
						tween.stop();
						sprite.destroy();
					}
				}
			});
			timeline.play();
		}

		const spine = this.scene.add.spine(0, 0, "player-impact-puff", "animation", false);
		const spineContainer = this.scene.add.spineContainer(0, 0, spine);
		if (this.parentContainer) this.parentContainer.add(spineContainer);
		else this.scene.add.existing(spineContainer);
		spineContainer.setPosition(this.x, this.y);
		spine.once("complete", () => {
			spine.destroy();
			spineContainer.destroy();
		});
		
		this.planckBody.velocity.x = 0;

		this.spine.play("hit", false);
		this.spine.once("complete", () => {
			this.spine.play("stun", true);
		});
	}
}